import {BASE_URL} from "app/config/env";

export const prefix = `${BASE_URL}/panel-player`;